import React from "react";
import { useNavigate } from "react-router-dom";
import AppButton from "./AppButton";

function NotFound() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="page-wrap d-flex flex-row align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 text-center">
              <span className="display-1 mt-5 d-block text-light">404</span>
              <div className="mb-4 lead text-light">
                The page you are looking for was not found.
              </div>
              <AppButton
                type="button"
                className="btn btn-dark w-100"
                onClick={() => {
                  navigate("/");
                }}
              >
                Back to Home Page
              </AppButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
